import { FC } from 'react'
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/shared/ui/Dialog/Dialog'
import { AlertDialogProps } from '@radix-ui/react-alert-dialog'
import { EditUnitAmenityForm } from '@/features/UnitAmenities/EditUnitAmenityForm'
import { useTranslation } from 'react-i18next'

type EditUnitAmenitiestModalProps = {
  dialogProps: AlertDialogProps
  currenUnitAmenityId: number
  onCloseModal: () => void
}

export const EditUnitAmenityModal: FC<EditUnitAmenitiestModalProps> = props => {
  const { dialogProps, currenUnitAmenityId, onCloseModal } = props
  const { t } = useTranslation(['amenity'])
  return (
    <Dialog {...dialogProps}>
      <DialogContent className={'overflow-y-auto max-h-[95vh]'}>
        <DialogHeader>
          <DialogTitle>{t('amenity:edit_amenity_title')}</DialogTitle>
          <EditUnitAmenityForm
            selectUnitAmenityId={currenUnitAmenityId}
            onCloseModal={onCloseModal}
          />
        </DialogHeader>
      </DialogContent>
    </Dialog>
  )
}
